
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-53fdf3fd&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./modal-automatic-value.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./modal-automatic-value.vue"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-53fdf3fd!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./modal-automatic-value.vue"),
  /* scopeId */
  "data-v-53fdf3fd",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/contract/modal-automatic-value.vue
// module id = 523
// module chunks = 1